export default __webpack_public_path__ + "544cae846aa7019e127147fade991115.png";